var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-time-picker',_vm._g(_vm._b({attrs:{"value":_vm.value,"locale":_vm.locale,"scrollable":_vm.scrollable,"format":_vm.format},on:{"input":_vm.on_input}},'v-time-picker',_vm.$attrs,false),_vm.unhandled_events),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }